/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import { shape, string } from 'prop-types';
import { FieldArray, Field } from 'formik';
import { Image, Confirm } from 'semantic-ui-react';
import Shape from 'Assets/images/pages/settings/shape.svg';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { TextAreaField, MaskedInputField } from 'Modules/Formik';
import { CirclePlus } from 'lucide-react';

import styles from '../PrescriptionForm.less';

const numberMaskPrice = createNumberMask({
  prefix: '',
  allowDecimal: true,
  includeThousandsSeparator: true,
  decimalLimit: 2,
});

const numberMaskQuantity = createNumberMask({
  prefix: '',
  includeThousandsSeparator: true,
});

const BasicFieldArray = props => {
  const [isOpenDeleteConfirm, setDeleteConfirm] = useState(false);
  const [indexMedicine, setIndexMedicine] = useState(0);

  const {
    values: { medicines },
    currencyCode,
  } = props;

  const removeMedicine = index => {
    setDeleteConfirm(true);
    setIndexMedicine(index);
  };

  const closeDeleteConfirm = () => {
    setDeleteConfirm(false);
  };

  return (
    <FieldArray
      name="medicines"
      render={arrayHelpers => (
        <div>
          <div className={styles.label}>Items</div>

          <div
            className={styles.insertMedicine}
            onClick={() => arrayHelpers.push({ description: '', quantity: '', price: '' })}>
            <CirclePlus className={styles.icon} size={16} color="#0984E3" />
            <span className={styles.text}>Insert another medicine</span>
          </div>

          {medicines.map((medicine, index) => (
            <div key={index}>
              <div className={styles.removeButton}>
                <button type="button" onClick={() => removeMedicine(index)} className={styles.btn}>
                  x
                </button>
                {isOpenDeleteConfirm && (
                  <Confirm
                    content="Remove medicine?"
                    cancelButton="Cancel"
                    confirmButton="Yes"
                    open={isOpenDeleteConfirm}
                    onCancel={closeDeleteConfirm}
                    onConfirm={() => {
                      arrayHelpers.remove(indexMedicine);
                      closeDeleteConfirm();
                    }}
                  />
                )}
              </div>
              <div>
                <div className={styles.labelField}>Name and directions</div>
                <Field
                  name={`medicines[${index}].description`}
                  maxlengthchar={500}
                  component={TextAreaField}
                />
              </div>
              <div className={styles.price}>
                <div className={styles.labelInputField}>Unit Price</div>
                <Field
                  name={`medicines[${index}].unitPrice`}
                  currencyCode={currencyCode}
                  mask={numberMaskPrice}
                  component={MaskedInputField}
                  excludeSeparator
                />
              </div>
              <div>
                <div className={styles.labelInputField}>Quantity</div>
                <Field
                  name={`medicines[${index}].quantity`}
                  mask={numberMaskQuantity}
                  component={MaskedInputField}
                  excludeSeparator
                />
              </div>
              <hr className={styles.borderHr} />
            </div>
          ))}
        </div>
      )}
    />
  );
};

BasicFieldArray.propTypes = {
  values: shape({}).isRequired,
  currencyCode: string.isRequired,
};

export default BasicFieldArray;
